// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Coin_wrapper__3kSb4","wrapperActive":"Coin_wrapperActive__3wcxX","text":"Coin_text__2hTxD","img":"Coin_img__3PZYc"};